import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Create, FileCopy } from '@material-ui/icons';
import axios from 'axios';
import { camelCase } from 'lodash';
import { mapKeysDeepLodash } from '../../../Campaign/utils/utils';
import { Preview } from '../../../components/dialogs/Prewiew';
import { Suspend } from '../../../components/dialogs/Suspend';
import { Reject } from '../../../components/dialogs/Reject';
import { Error } from '../../../components/dialogs/Error';
import { useAuth } from '../../../context/auth';
import { Status } from '../../../statuses';
import { 
    Button, 
    HeaderContainer, 
    HeaderWrapper, 
    StyledButton, 
    StyledIconButton, 
    StyledLoading
} from '../../CampaignDetails.styles';
import { HeaderProps } from './Header.interface';

export function Header({ 
    id, 
    title, 
    status, 
    refresh, 
    adminAccess, 
    mediaFile, 
    mobileFile, 
    desktopFile, 
    pollDetails, 
    adType }: HeaderProps) {
    const [showSuspend, setShowSuspend] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoadingData, setIsLoadingData] = useState(false);
    const { authToken, refreshDovePoints } = useAuth();
    const history = useHistory();

    const duplicateCampaign = () => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${id}/edit/`, { headers: { DTOKEN: `${authToken}` } }).then(res => {
            const mappedValues = mapKeysDeepLodash(res.data, (v: any, k: any) => camelCase(k));
            sessionStorage.setItem('disabledTypeChange', 'true');
            history.push(`${process.env.REACT_APP_INTERNAL_URL}create-campaign`, { initialDuplicateValues: {...mappedValues, basicInformation: {...mappedValues.basicInformation, title: `${mappedValues.basicInformation.title} copy`}, content: {...mappedValues.content, campaignType: mappedValues.basicInformation.adType}} })
        })
    };
    const editCampaign = (title: string) => {
        sessionStorage.setItem('disabledTypeChange', 'true');
        sessionStorage.setItem('oldTitle', `${title}`)
        history.push(`${process.env.REACT_APP_INTERNAL_URL}campaign/edit/${id}`)
    }
    const sendForApproval = () => {
        setIsLoadingData(true);
        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${id}/send-for-approval/`, {}, { headers: { DTOKEN: `${authToken}` } }).then(() => {
            refresh();
            setIsLoadingData(false);
        })
    }
    const approveCampaign = () => {
        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${id}/approve/`, {}, { headers: { DTOKEN: `${authToken}` } })
            .then(() => {
                refresh();
            })
            .catch(error => {
                setErrorMessage(error.response.data.message);
                setShowError(true);
            })
    }
    const startCampaign = () => {
        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${id}/start/`, {}, { headers: { DTOKEN: `${authToken}` } }).then(() => {
            refresh();
        })
        .catch(error => {
            setErrorMessage(error.response.data.message);
            setShowError(true);
        })
    }
    const stopCampaign = () => {
        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${id}/stop/`, {}, { headers: { DTOKEN: `${authToken}` } }).then(() => {
            refresh();
        })
    }
    return (
        <>
            <HeaderWrapper>
                <HeaderContainer>
                    <h1>{title}</h1>
                    <div>
                        <StyledIconButton onClick={() => duplicateCampaign()}><FileCopy /></StyledIconButton>
                        {adminAccess 
                            ?
                                <>
                                    {status === Status.WaitingForApproval &&
                                        <>
                                            <Button onClick={() => setShowPreview(true)}>Preview</Button>
                                            <Button onClick={() => setShowReject(true)}>Reject</Button>
                                            <StyledButton onClick={approveCampaign}>Approve</StyledButton>
                                        </>
                                    }
                                    {status === Status.NotApproved && <StyledButton onClick={approveCampaign}>Approve</StyledButton>}
                                    {status === Status.Suspended && <StyledButton onClick={approveCampaign}>Make active</StyledButton>}
                                    {status === Status.Active && <StyledButton onClick={() => setShowSuspend(true)}>Suspend</StyledButton>}
                                    {status === Status.Stopped && <StyledButton onClick={() => setShowSuspend(true)}>Suspend</StyledButton>}
                                </>
                            :
                                <>
                                    {(status === Status.Draft || status === Status.NotApproved) &&
                                        <>
                                            <StyledIconButton onClick={() => editCampaign(title)}><Create /></StyledIconButton>
                                            <Button onClick={() => setShowPreview(true)}>Preview</Button>
                                            <StyledButton onClick={sendForApproval}>{isLoadingData && <StyledLoading size="20px" />}Send for approval</StyledButton>
                                        </>
                                    }
                                    {status === Status.Active && <StyledButton onClick={stopCampaign}>Stop</StyledButton>}
                                    {status === Status.Stopped && <StyledButton onClick={startCampaign}>Start</StyledButton>}
                                </>
                        }
                        
                    </div>
                </HeaderContainer>
            </HeaderWrapper>
            <Suspend open={showSuspend} setOpen={setShowSuspend} campaignId={id} refresh={refresh} />
            <Reject open={showReject} setOpen={setShowReject} campaignId={id} refresh={refresh} />
            <Error open={showError} setOpen={setShowError} message={errorMessage} />
            <Preview
                open={showPreview}
                setOpen={setShowPreview}
                image={mediaFile || desktopFile}
                imageMobile={mobileFile}
                video={mediaFile}
                adType={adType}
                pollDetails={pollDetails}
            />
        </>
    )
}
